import { render } from "./CollapsePanel.vue?vue&type=template&id=20aff229&scoped=true"
import script from "./CollapsePanel.vue?vue&type=script&lang=js"
export * from "./CollapsePanel.vue?vue&type=script&lang=js"

import "./CollapsePanel.vue?vue&type=style&index=0&id=20aff229&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20aff229"]])

export default __exports__